<script lang="ts">
    import type {NatsConnection, ConnectionOptions, Msg, NatsError} from "nats.ws";
    // @ts-ignore
    import {NatsNegConnection, NatsState} from "./natsneg"
    // @ts-ignore
    import {DiscoverLocalInfo} from "./nttrtc/iface_discovery"
    import type {LocalInfo} from "./nttrtc/iface_discovery"
    import Menu from '@smui/menu';
    import Button from '@smui/button';
    import List, {Item, Graphic, Separator, Text, PrimaryText, SecondaryText} from '@smui/list';
    import NatsViewer from "./NatsViewer.svelte";
    import { AuthPromise } from "../auth";
    import MapWindow from "./MapWindow.svelte";
    import { onDestroy, onMount } from "svelte";

    interface RtcViewport {
        pubKey: string
        title: string
    }

    interface Discovery {
        id: string
        role: string
        pubKey: string
        selected: boolean
    }
    
    interface DiscoveryLike {
        pubKey: string
        selected: boolean
    }

    interface DiscoveryUI {
        displayName: string
        pubKey: string
        discovery: Discovery | null
    }

    export let role: string = ""
    let peerPub = ""
    let clientsList: any
    let settingsMenu: any
    let debug = false

    function peer(): string {
        if (role == "v") return "s"
        return "v"
    }

    let mapWindow: MapWindow

    let natsState: NatsState = NatsState.NotConnected
    let neg: NatsNegConnection | null = null
    let discoveries: Array<Discovery> = []
    let knownStreamerNames: {[i: string]: string} = {}
    let knownStreamers: Array<Discovery> = []
    let discoSocket: WebSocket | null = null
    let discoConnected = false
    let myInfo: any = null
    
    let discoveryUi: DiscoveryUI[] = []
    
    $: knownStreamers =  discoveries.filter((v) => (knownStreamerNames[v.pubKey] != undefined))
    
    let fillDiscoveries = (known: {[i: string]: string}, discoveries: Array<Discovery>) => {
        let ret: DiscoveryUI[] = []
        for (let pubKey in known) {
            let name = known[pubKey]
            let disc = discoveries.find((d) => d.pubKey == pubKey)
            if (disc == undefined) {
                ret.push({displayName: name, pubKey: pubKey, discovery: null})
            } else {
                ret.push({displayName: name, pubKey: pubKey, discovery: disc})
            }
        }
        ret.sort((a,b) => a.displayName.localeCompare(b.displayName))
        return ret
    }
    $: discoveryUi = fillDiscoveries(knownStreamerNames, discoveries)

    let errorHandler = (err: any) => {
        console.log(err)
        natsState = NatsState.NotConnected
    }
    
    let localInfoGathered: Promise<LocalInfo> = DiscoverLocalInfo({iceServers: [{urls: "stun:stun.l.google.com:19302"}]})
    // localInfoGathered.then((info) => {
    //     localInfo = info
    // })


    function fetchOwnName(authRet: any) {
        fetch('/api/v1/actors/me').then(async (resp) => {
            console.log("auth", authRet)
            let jsonData = await resp.json() as Array<any>
            myInfo = jsonData[0]
        }).catch((e) => errorHandler(e))
    }

    function fetchStreamerNames() {
        fetch('/api/v1/streamers/').then(async (resp) => {
            let jsonData = await resp.json() as Array<any>
            jsonData.forEach((val) => {
                knownStreamerNames[val.nid as string] = val.name
            })
            knownStreamerNames = knownStreamerNames
        }).catch((e) => errorHandler(e))
    }

    function natsConnect(jwt: any) {
        natsState = NatsState.Connecting
        let opts: ConnectionOptions = {servers: ['wss://'+window.location.host+'/nats']}
        neg = new NatsNegConnection(opts, {unsignedJwt: jwt})
        neg.onConnectionStateChanged = (ns: NatsState) => {
            natsState = ns

            if (ns == NatsState.Connected && role == "s") {
                window.alert("Streamer is not implemented")
            }
        }
        neg.onDiscoveredPeer = (msg: Msg) => {
            let subj = msg.subject
            let found = false
            // neg.announce.role.pub
            let parts = subj.split('.')
            let obj = {id: subj, role: parts[2], pubKey: parts[3], selected: false}

            for (let i = 0; i<discoveries.length; ++i) {
                if (discoveries[i].id == subj) {
                    discoveries[i] = obj
                    found = true
                    break
                }
            }
            if (!found) {
                discoveries = [...discoveries, obj] 
            }
        }
        neg.onLostPeer = (msg: Msg) => {
            let subj = msg.subject
            for (let i = 0; i<discoveries.length; ++i) {
                if (discoveries[i].id == subj) {
                    discoveries.splice(i,1)
                    discoveries = discoveries
                    return
                }
            }
        }
    }

    // docs: https://zoka.pro4sec.com/docs/rtc/-/blob/master/GracefulDisconnect.md
    function discoConnect() {
        discoSocket = new WebSocket('wss://'+window.location.host+'/api/v1/disco', "disco") 
        discoSocket.onopen = (ev) => {
            discoConnected = true
        }
    }

    // DSZ: blws/auth/wi/view, Web View authorization
    // Authorizes web browser with blws/auth/wi/get
    AuthPromise.then((ret) => {
        natsConnect(ret)
        fetchStreamerNames()
        fetchOwnName(ret)
        discoConnect()
    }).catch(errorHandler)

    let viewerArray: Array<RtcViewport> = []
    function toggleClient(e: Event, disc: DiscoveryLike|null) {
        if (disc == null) {
            return
        }
        // Clicking stuck reconnected viewers should disconnect those
        if (viewerArray.find((vp) => (vp.pubKey == disc.pubKey))) {
            disc.selected = true
        }
        disc.selected = !disc.selected
        // Propagate to UI
        discoveries = discoveries
        if (disc.selected) {
            viewerArray = [...viewerArray, {pubKey: disc.pubKey, title: knownStreamerNames[disc.pubKey]}]
        } else {
            for (let i = 0; i<viewerArray.length; i++) {
                if (viewerArray[i].pubKey == disc.pubKey) {
                    viewerArray.splice(i, 1)
                    viewerArray = viewerArray
                    break
                }
            }
        }
    }

    function rmFake(pub: string) {
        for (let i = 0; i<viewerArray.length; i++) {
            if (viewerArray[i].pubKey == pub) {
                viewerArray.splice(i, 1)
                viewerArray = viewerArray
                break
            }
        }
    }

    let changeLeader = (pubKey: string) => {
        if (viewerArray.length == 0 || viewerArray[0].pubKey == pubKey) {
            return
        }
        for (let i = 0; i<viewerArray.length; i++) {
            if (viewerArray[i].pubKey == pubKey) {
                let ejected = viewerArray[i]
                viewerArray[i] = viewerArray[0]
                viewerArray[0] = ejected
                viewerArray = viewerArray
                break
            }
        }
    }

    let nonce = 123
    function addPub() {
        nonce++
        viewerArray = [...viewerArray, {pubKey: ""+nonce, title: "Debug"}]
    }

    let leaderMode = false
    let isAdmin = false

    fetch("/api/v1/actor_groups/").then((resp) => {
        isAdmin = (Math.trunc(resp.status / 100) == 2)
    })

    onDestroy(() => {
        if (discoSocket) {
            discoSocket.close()
        }
        if (neg) {
            neg.nats.close()
        }
    })

</script>

<style>
    .viewer {
        --containerSize: 100vw;
    }

    @media (min-width: 1400px) {
        .viewer {
            --containerSize: 1320px;
        }
    }

    .viewer-grid {
        display: grid;
        grid-template-columns: 50% 50%;
        --leaderFrac: 0.5;
    }
    .viewer-grid-leader {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        --leaderFrac: 0.2;
    }

    .viewer-grid-leader div{
        padding: 2px;
    }
    .leader {
        grid-column: 1 / span 4;
        grid-row: 1 / span 3;
        --leaderFrac: 0.8;
    }
    .colspan {
        grid-column: 1 / span 2;
        --leaderFrac: 1;
    }

    .row {
        --bs-gutter-x: 0;
    }
    .hidden {
        display: none;
    }

</style>

<MapWindow bind:this={mapWindow}/>

{#if debug}
{#if natsState == NatsState.Connected}
<table>
    {#each discoveries as discovery, i (discovery.id)}
    <tr>
        <td>{i+1}</td><td>{discovery.role}</td><td>{discovery.pubKey}</td>
    </tr>
    {/each}
</table>
{#if peerPub != ""}
    Connecting to {peerPub}
{/if}
{/if}
{/if}


{#if debug}
<Button on:click={addPub}>Add fake</Button>
{/if}

<div class="row" class:hidden={!discoConnected}>
    <div class="col-md-3">
        <Button on:click={() => {clientsList.setOpen(true)}} ripple={false}>Connect to... ({viewerArray.length}/{knownStreamers.filter((d)=>(d.role == "s")).length})</Button>
        <Menu bind:this={clientsList} class="z-menu" anchorCorner="BOTTOM_LEFT">
            <List>
                {#each discoveryUi as dui, i (dui.pubKey)}
                    <Item on:SMUI:action={(e) => toggleClient(e, dui.discovery || {pubKey: dui.pubKey, selected: true})}>
                        {#if dui.discovery}
                            <span class="material-icons-outlined" style="color: #27ae60;"> check_circle </span>
                        {:else}
                            <span class="material-icons-outlined" style="color: #c0392b;"> highlight_off </span>
                        {/if}
                        <Text class="text-menu">{dui.displayName}</Text>
                        

                        <div style="flex-grow: 1; text-align: end;">
                        {#if viewerArray.find((vp) => (vp.pubKey == dui.pubKey))}
                            <label class="switch" style="pointer-events: none;">
                                <input type="checkbox" checked/>
                                <span class="slider round"></span>
                            </label>
                        {:else}
                            {#if dui.discovery}
                                <label class="switch" style="pointer-events: none;">
                                    <input type="checkbox" checked={dui.discovery.selected}/>
                                    <span class="slider round"></span>
                                </label>
                            {/if}
                        {/if}
                        </div>
                        
                    </Item>
                {/each}
            <Separator />
            <Item on:SMUI:action={() => clientsList.setOpen(false)}><Text>Close</Text></Item>
            </List>
        </Menu>
    </div>
    <div class="col-md-3">
        <Button on:click={() => leaderMode = true} ripple={false}><span class="material-icons">view_sidebar</span></Button>
        <Button on:click={() => leaderMode = false} ripple={false}><span class="material-icons">grid_view</span></Button>
    </div>
    <div class="col-md-6" style="text-align: right;">
        <div style="display: inline-block;">
        <Button on:click={() => {settingsMenu.setOpen(true)}} ripple={false}><span class="material-icons">settings</span></Button>
        <Menu bind:this={settingsMenu} class="z-menu" anchorCorner="BOTTOM_LEFT">
            <List>
                {#if isAdmin}
                    <Item>
                        <a class="divLink" href="/mgr" tinro-ignore tabindex="-1">&nbsp;</a>
                        <Graphic class="material-icons">build</Graphic><Text>Go to server config</Text>
                    </Item>
                    <Item on:SMUI:action={() => debug = !debug}>
                        <Graphic class="material-icons">pest_control</Graphic><Text>Toggle debug ({debug?"enabled":"disabled"})</Text>
                    </Item>
                {/if}
                <Item>
                    <a class="divLink" href="/logout" tinro-ignore tabindex="-1">&nbsp;</a>
                    <Graphic class="material-icons">logout</Graphic><Text>Sign out</Text>
                </Item>
                <Separator />
                <Item on:SMUI:action={() => settingsMenu.setOpen(false)}><Text>Close</Text></Item>
            </List>
        </Menu>
        </div>
    </div>
</div>

{#if neg != null}
<div class:viewer-grid={!leaderMode} class:viewer-grid-leader={leaderMode} class:viewer={true}>
{#each viewerArray as v, i (v.pubKey)}
<div class:leader={leaderMode && i == 0} class:colspan={!leaderMode && (viewerArray.length % 2 == 1 && i == viewerArray.length-1)}>
    {#if debug}
        <Button on:click={()=>rmFake(v.pubKey)}>Rm</Button>
    {/if}
    {#if leaderMode && i != 0}
        <Button on:click={() => changeLeader(v.pubKey)} ripple={false}><span class="material-icons">reply</span></Button>
    {/if}
    <NatsViewer myInfo={myInfo} disco={discoSocket} debug={debug} title={v.title} neg={neg} peerPub={v.pubKey} localInfoGathered={localInfoGathered} mapWindow={mapWindow} isLeader={!leaderMode || i == 0}/>
</div>
{/each}
</div>
{/if}
